import { useEffect, useState } from 'react';
import { usePrismicDocumentByUID } from '@prismicio/react';
import { Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import theme from 'src/style-system/theme';
import ModalComponent from '@components/ModalComponent';
import CuminButton from '@components/Button';
import PageLoader from '@components/PageLoader';
import useEffectExcludingMount from '@utils/useEffectExcludingMount';
import FAQ from '@components/FAQ';

import { useStyles } from './useStyles';

const NewFlowFAQ = ({ pageName }: { pageName: string }) => {
  const [faqOpen, setFaqOpen] = useState<boolean>(false);

  const [faqContent, { state, error }] = usePrismicDocumentByUID(
    'faq_component',
    'order-step-1-faq'
  );

  const classes = useStyles();

  const handleClose = () => {
    setFaqOpen(false);
  };

  // for GA event
  useEffectExcludingMount(() => {
    if (faqOpen) {
      //@ts-ignore
      window?.dataLayer.push({
        text: pageName,
        event: 'faq_box_open',
      });
    } else {
      //@ts-ignore
      window?.dataLayer.push({
        text: pageName,
        event: 'faq_box_close',
      });
    }
  }, [faqOpen]);

  return (
    <>
      <CuminButton
        color="turmeric"
        variant="contained"
        textColor="garamMasala.main"
        borderRadius="24"
        className={classes.faqBtn}
        onClick={() => setFaqOpen(true)}
      >
        FAQs
      </CuminButton>
      <ModalComponent open={faqOpen} handleClose={handleClose}>
        {state !== 'loaded' ? (
          <Box width="80vw">
            <PageLoader height="80vh" />
          </Box>
        ) : (
          <Box
            sx={{
              width: 'max-content',
              maxWidth: '80vw',
              height: '80vh',
              padding: '50px 60px',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              rowGap: '20px',
              borderRadius: '15px',
              [theme.breakpoints.down('md')]: {
                maxWidth: '90vw',
                padding: '30px 50px',
              },
              [theme.breakpoints.down('sm')]: {
                padding: '30px 12px',
              },
            }}
          >
            <Box
              sx={{
                overflowY: 'auto',
                width: '100%',
                height: '100%',
                /* width */
                '&::-webkit-scrollbar': {
                  width: '8px',
                },

                /* Track */
                '&::-webkit-scrollbar-thumb': {
                  background: theme.palette.turmeric.main,
                  borderRadius: '4px',
                },
              }}
            >
              <CloseIcon
                sx={{
                  color: 'garamMasala.main',
                  cursor: 'pointer',
                  position: 'absolute',
                  top: '12px',
                  right: '8px',
                  [theme.breakpoints.up('sm')]: {
                    top: '15px',
                    right: '15px',
                  },
                }}
                onClick={handleClose}
              />
              <FAQ faqContent={faqContent} />
            </Box>
          </Box>
        )}
      </ModalComponent>
    </>
  );
};

export default NewFlowFAQ;
